/*
 * Copyright (c) 2025. Sergey S. Chernov - All Rights Reserved
 *
 *  You may use, distribute and modify this code under the
 * terms of the private license, which you must obtain from the author
 *
 * To obtain the license, contact the author: https://t.me/real_sergeych or email to
 * real dot sergeych at gmail.
 */

package net.sergeych.kiloparsec

/**
 * Minimal data to create kiloparsec connection: transport device and a new session object.
 */
data class KiloConnectionData<S>(
    val device: Transport.Device,
    val session: S
)

/**
 * callback that creates new [Transport.Device] and session objects for Kiloparsec connections.
 */
typealias ConnectionDataFactory<S> = suspend ()->KiloConnectionData<S>
